import { memo, type ReactNode } from "react";

type HrProps = {
  className?: string;
  bookable?: boolean;
};

export const Hr = memo(({ className = "", bookable }: HrProps): ReactNode => {
  const borderColor = bookable === true ? "border-neutral-100" : "border-gray-300";

  return <hr className={`border-[0.5px] my-2 ${borderColor} ${className}`} />;
});
